import http from '~/common/http'

//日志列表
function index(params){
    return http.get('/api/sys-log/index', {params:params})
}

export default {
    index,
}


// WEBPACK FOOTER //
// ./src/services/syslog.js